/**
 * Global-child - assets/js
 */

/**
 * Vanilla JS
 */

/**
 * Swiper.
 */
let swiperOptionFade = {
	loop: true,
	effect: 'fade',
	autoplay: {
		delay: 4000,
		stopOnLastSlide: true,
	},
	speed: 4000,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
	},
};
let swiperOptionEvent = {
	loop: true,
	slidesPerView: 2,
	spaceBetween: 16,
	autoplay: {
		delay: 4000,
		disableOnInteraction: false,
	},
	speed: 3000,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},

	breakpoints: {
		767: {
			slidesPerView: 1,
			spaceBetween: 0,
		},
	},
};
let sliderFront = new Swiper( '.swiper-container', swiperOptionFade );
let sliderEvent = new Swiper( '.event-swiper-container', swiperOptionEvent );

/**
 * スマホメニューのページ内リンク対応.
 */
document.addEventListener('DOMContentLoaded', function () {
	const NavText = document.querySelectorAll('.menu-item a');
	const Hamburger = document.getElementById('btn-hamburger');
	for (let i = 0; i < NavText.length; i++) {
		NavText[i].addEventListener('click', function () {
			Hamburger.checked = false;
		});
	}
});

/**
 * jQuery
 */
jQuery( document ).ready( function( $ ) {
});
